<template>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Relatórios de Unidades") }}
      </h1>

      <b-dropdown
        no-caret
        variant="primary"
        size="sm"
        v-b-tooltip.hover
        right
        title="Menu de Relatórios de Unidades"
      >
        <template #button-content>
          Menu
          <i class="fas fa-bars"></i>
        </template>
        <b-dropdown-group id="dropdown-group-1" header="Relatórios de Unidades">
          <b-dropdown-item
            :to="'/dashboard/relatorios/unidades/home'"
            :diabled="$route.home == 'relatorios_home_unidades'"
          >
            Todas as Unidades
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/unidades/graficos'"
            :disabled="$route.name == 'graficos_unidades'"
          >
            Gráficos de Unidades
          </b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
    </div>
    <div class="col-md-12">
      <load v-if="loading" />
      <router-view v-else />
    </div>
  </div>
</template>
<script>
export default {
  name: "ReportsUnidades",
  metaInfo() {
    return {
      title: this.$i18n.t("Relatórios de Unidades"),
    };
  },
  mounted() {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
};
</script>
